import axios from "axios";

export const setVNCAPI = async (
  deviceData,
  nubisVersion,
  newVnc = true,
  type
) => {
  const apiUrl = newVnc
    ? `/api/v2/command/obtain-vnc-new`
    : `/api/v2/command/obtain-vnc`;

  try {
    let response = await axios({
      url: apiUrl,
      method: "POST",
      data: {
        device_id: deviceData?.id,
        nubis_version: nubisVersion
      }
    });

    const task_id = response.data.task.id;
    return { task_id: task_id, task_data: response.data };
  } catch (error) {
    if (type === "deviceDetail") {
      window.location.assign(
        `/device-list/device-detail/${deviceData?.id}/${deviceData?.os_type}`
      );
    } else {
      window.location.assign("/groups/groups-devices");
    }
  }
};
